import { BatchSuggestionWithGroupsSchema } from "@redotech/redo-model/fulfillments/batch-suggestion";
import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import * as z from "zod";

export const getBatchSuggestionsByKeys = {
  name: "getBatchSuggestionsByKeys" as const,
  input: z.object({
    batchKeys: z.array(z.string()),
    advancedFiltersInput: AdvancedFilterInputSchema,
  }),
  output: z.object({ suggestions: z.array(BatchSuggestionWithGroupsSchema) }),
};
